exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.login-protocol-qb {\n  background-color: #FAFAFA;\n  padding-bottom: 0.6rem;\n}\n.login-protocol-qb .content {\n  padding: 0 0.466667rem 1.2rem;\n  border-radius: 0.266667rem;\n  background-color: #FFFFFF;\n  overflow: hidden;\n  text-indent: 0.053333rem;\n}\n.login-protocol-qb .content p {\n  margin-top: 0.16rem;\n  font-size: 0.346667rem;\n  line-height: 0.44rem;\n  font-family: PingFangSC-Regular, PingFang SC;\n  font-weight: 400;\n  color: #666666;\n}", ""]);

// exports
